import React, { useEffect, useState, useRef } from 'react';
import './TauriApplicationSelection.css';
import TauriMenuHeader from './TauriMenuHeader/TauriMenuHeader';

const TauriApplicationSelection = ({ menuList, headerStyle, submenuStyle, buttonIconStyle, submenuIconStyle, onItemSelected, onHeaderClick }) => {
    const submenuRef = useRef(null);
    const [submenuVisible, setSubmenuVisible] = useState(false);
    const [headerSelected, setHeaderSelected] = useState([]);

    const handleClickOutside = (event) => {
        if (submenuRef.current && !submenuRef.current.contains(event.target)) {
            const submenus = document.querySelectorAll('.submenu');
            submenus.forEach(submenu => submenu.classList.remove('show'));
            setSubmenuVisible(false);
        }
    };
    
    const toggleMenu = (e) => {
        e.stopPropagation();
        const submenu = e.target.closest('li').querySelector('ul');

        if (!submenu) return;

        if (submenu.classList.contains('show')) {
            submenu.classList.remove('show');
            setSubmenuVisible(false);

        } else {
            handleClickOutside(e); // Close other dropdowns
            submenu.classList.add('show');
            setSubmenuVisible(true);
        }
    };

    const handleMouseLeave = (e) => {
        const submenu = e.currentTarget.querySelector('ul');
        submenu?.classList.remove('show');
    };

    const handleSubmenuItemClicked = (hasSubmenu, child, parent) => {
        if (!hasSubmenu) {
            onItemSelected(parent, child);
            setHeaderSelected(parent);
            handleClickOutside({ target: document });
        }
    };

    const handleHeaderClick = (parent) => {
        onHeaderClick(parent);
        setHeaderSelected(parent);
    } 

    const renderMenu = (subMenu) => {
        return (
            <TauriMenuHeader
                subMenu={subMenu}
                submenuIconStyle={submenuIconStyle}
                submenuStyle={submenuStyle}
                toggleMenu={toggleMenu}
                handleMouseLeave={handleMouseLeave}
                handleSubmenuItemClicked={handleSubmenuItemClicked}
                submenuRef={submenuRef}
                onClick={handleHeaderClick}
            />
        );
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className='app-section'>
            <ul style={headerStyle}>
                {menuList.map((item, index) => (
                    <li key={index} onClick={(e) => toggleMenu(e, item.name)}>
                        <img src={headerSelected.length === 0 ? process.env.PUBLIC_URL + item.icon : process.env.PUBLIC_URL + headerSelected.icon} style={buttonIconStyle} alt="arrow"/>
                        {headerSelected.length === 0 ? item.name : headerSelected.name}
                        {item.modules && (
                            <span className={`dropdown-icon-header ${submenuVisible ? 'up' : 'right'}`}>
                                &#9650;
                            </span>
                        )}
                        {item.modules && renderMenu(item.modules)}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TauriApplicationSelection;
